import React, { Component } from 'react'
import CustomSpin from '../elements/CustomSpin'

class TableSpin extends Component {
  render() {
    {
      return this.props.loading ? (
        <div className="-loading -active">
          <div className="-loading-inner">
            <CustomSpin />
          </div>
        </div>
      ) : null
    }
  }
}

TableSpin.propTypes = {}
TableSpin.defaultProps = {}

export default TableSpin
